import React, { useMemo, useState } from 'react';
import { ICastingRoleAttributes } from 'shared/interfaces/ICastingRole';

import { SelectionContainer, Heading, MainContainer, SelectionButton } from './Information.styles';
import { IAuditionScheduleAttributes } from 'shared/interfaces/IAuditionSchedule';
import ProjectRoleInfo from 'pages/AuditionRequest/ProjectRoleInfo';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CollapsibleProjectRoleInfo from './CollapsibleProjectRoleInfo';
import { DoubleUpArrowIconTwoTone } from '@room-match/shared-ui-components';
import { auditionScheduleService } from 'shared/services/auditionScheduleService';

interface Props {
  auditionSchedule?: IAuditionScheduleAttributes;
  auditionSchedId?: string;
}

const { getSpecificAuditionSchedule } = auditionScheduleService();

const Information: React.FC<Props> = ({ auditionSchedule, auditionSchedId }) => {
  const [expanded, setExpanded] = useState(!auditionSchedId);

  const { data: auditionScheduleData, isLoading } = getSpecificAuditionSchedule(auditionSchedId || '');
  const getAuditionScheduleData = useMemo(() => {
    if (isLoading) {
      return;
    } else {
      return auditionScheduleData ? auditionScheduleData?.data.audition_schedule : undefined;
    }
  }, [auditionScheduleData, isLoading]);

  return (
    <MainContainer id={`role-proj-info-container-${auditionSchedId}`}>
      <Accordion
        expanded={expanded}
        onChange={(event) => {
          setExpanded(!expanded);
          //   if (!expanded) {
          const el = document.querySelector(`#role-proj-info-container-${auditionSchedId}`);
          if (el) {
            const y = el.getBoundingClientRect().top + window?.pageYOffset - 60;
            window?.scrollTo({ top: y, behavior: 'smooth' });
          }
          //   }
        }}
        style={{ backgroundColor: 'transparent', margin: 0, border: 'none', boxShadow: 'none' }}
      >
        <AccordionSummary
          expandIcon={<DoubleUpArrowIconTwoTone style={{ marginRight: 10 }} />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Heading fontSize={18}>Role / Project Information</Heading>
        </AccordionSummary>
        <AccordionDetails>
          <SelectionContainer>
            <CollapsibleProjectRoleInfo auditionSchedule={auditionSchedule || getAuditionScheduleData} />
          </SelectionContainer>
        </AccordionDetails>
      </Accordion>
    </MainContainer>
  );
};

export default Information;
